import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-16-bootstrap-date-picker';

class DatePicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.id,
            name: this.props.name,
            onChange: this.props.onChange,
            showClearButton: this.props.showClearButton,
            disabled: this.props.disabled,
            defaultValue: this.props.defaultValue,
            value: this.props.value,
            minDate: this.props.minDate,
            maxDate: this.props.maxDate,
            style: this.props.style,
            className: this.props.className,
            autoComplete: this.props.autoComplete,
            dateFormat: this.props.dateFormat,
            showTodayButton: this.props.showTodayButton,
            required: this.props.required
        };
        this.onChange = this.onChange.bind(this);
    }

    componentWillReceiveProps(nextProps, nextState) {
        this.setState({
            id: nextProps.id,
            name: nextProps.name,
            onChange: nextProps.onChange,
            showClearButton: nextProps.showClearButton,
            disabled: nextProps.disabled,
            defaultValue: nextProps.defaultValue,
            value: nextProps.value,
            minDate: nextProps.minDate,
            maxDate: nextProps.maxDate,
            style: nextProps.style,
            className: nextProps.className,
            autoComplete: nextProps.autoComplete,
            dateFormat: nextProps.dateFormat,
            showTodayButton: nextProps.showTodayButton,
            required: nextProps.required
        });
    }

    onChange(value, formattedValue) {
        let { name, onChange } = this.state;

        onChange(name, value);
    }

    render() {
        let {
            id,
            name,
            showClearButton,
            disabled,
            defaultValue,
            value,
            minDate,
            maxDate,
            style,
            className,
            autoComplete,
            dateFormat,
            showTodayButton,
            required
        } = this.state;
        return (
            <div id={id ? id : name}>
                <ReactDatePicker
                    id={id}
                    name={name}
                    onChange={this.onChange}
                    showClearButton={showClearButton}
                    disabled={disabled}
                    defaultValue={defaultValue}
                    value={value}
                    minDate={minDate}
                    maxDate={maxDate}
                    style={style}
                    className={className}
                    autoComplete={autoComplete}
                    dateFormat={dateFormat}
                    showTodayButton={showTodayButton}
                />
                {/*Following hidden input is added for parsley validation*/}
                <input
                    type="text"
                    style={{ display: 'none' }}
                    value={value}
                    readOnly
                    data-parsley-required={required}
                    data-parsley-class-handler={'#' + (id ? id : name)}
                />
            </div>
        );
    }
}

DatePicker.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    showClearButton: PropTypes.bool,
    disabled: PropTypes.bool,
    defaultValue: PropTypes.string,
    value: PropTypes.string,
    minDate: PropTypes.string,
    maxDate: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    autoComplete: PropTypes.string, //Example: off
    dateFormat: PropTypes.string, //Examples: "MM/DD/YYYY", "YYYY/MM/DD", "MM-DD-YYYY", or "DD MM YYYY"
    showTodayButton: PropTypes.bool,
    required: PropTypes.bool
};

DatePicker.defaultProps = {
    showClearButton: true,
    disabled: false,
    dateFormat: 'MM/DD/YYYY',
    required: false
};

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/DatePicker/index.js